import { BaseResponse } from './../common/BaseResponse';
import { CompactUserResponse } from '@business/entities/account';
import { FCFormDataType } from '@modules/settings/SettingsPage/Components/FormsTab/FormFields/types';

export enum FormTypes {
  all = 'all',
  organization = 'organization',
  project = 'project',
  marketing = 'marketing',
  subcontractor = 'subcontractor',
}

export type FormId = string;

export interface FormResponse {
  id: FormId;
  title: string;
  description?: string;
  types: FormTypes[];
  settings: any;
  fields: FCFormDataType[];
  isPublic: boolean;
}

export interface FormValueHistoryResponse extends BaseResponse {
  id: string;
  type: 'created' | 'updated' | 'shared';
  user: CompactUserResponse;
  values: [];
}

export type CompactFormResponse = Omit<FormResponse, 'settings' | 'fields'>;
